export type DashboardAppName =
  | 'home'
  | 'kerelemek'
  | 'foglalasok'
  | 'analytics'
  | 'reservation_seating'
  | 'beosztas'
  | 'settings'
  | 'todos'
  | 'admin_todos'
  | 'elerhetosegek'
  | 'tudastar'
  | 'keszlet'
  | 'velemenyek'
  | 'berezesem'
  | 'unit_settings'
  | 'admin_kozpont'
  | 'adminisztracio'
  | 'design_system'
  | 'theme_studio'
  | 'audit_logs'
  | 'my_activity'
  | 'szavazasok'
  | 'chat';

export const DASHBOARD_APP_IDS: DashboardAppName[] = [
  'home', 'kerelemek', 'foglalasok', 'analytics', 'reservation_seating', 'beosztas', 'settings', 'todos', 'admin_todos', 'elerhetosegek',
  'tudastar', 'keszlet', 'velemenyek', 'berezesem', 'unit_settings', 'admin_kozpont', 'adminisztracio',
  'design_system', 'theme_studio', 'audit_logs', 'my_activity', 'szavazasok', 'chat',
];

const DASHBOARD_APP_ID_SET = new Set<string>(DASHBOARD_APP_IDS);

const normalizePathname = (pathname?: string | null): string => {
  const trimmed = typeof pathname === 'string' ? pathname.trim() : '';
  return trimmed || '/';
};

export const getDashboardAppFromPath = (pathname: string): DashboardAppName | null => {
  const normalizedPathname = normalizePathname(pathname);
  if (normalizedPathname === '/admin/design-system') return 'design_system';
  if (normalizedPathname === '/admin/theme-studio') return 'theme_studio';

  const dashboardMatch = /^\/dashboard(?:\/([^/?#]+))?\/?$/.exec(normalizedPathname);
  if (!dashboardMatch) return null;

  const routeAppId = dashboardMatch[1] ? decodeURIComponent(dashboardMatch[1]) : 'home';
  return DASHBOARD_APP_ID_SET.has(routeAppId) ? routeAppId as DashboardAppName : null;
};

export const resolveInitialDashboardAppFromLocation = (
  locationLike: Pick<Location, 'pathname'> | null | undefined = typeof window !== 'undefined' ? window.location : undefined
): DashboardAppName => getDashboardAppFromPath(locationLike?.pathname || '/') ?? 'home';
